// Application identity; the values come from package.json at build time.
export const app = {
  name: __APP_NAME__,
  version: __APP_VERSION__,
  label: `${__APP_NAME__} v${__APP_VERSION__}`,
}
